import { render, staticRenderFns } from "./starsParts.vue?vue&type=template&id=3116777a&"
import script from "./starsParts.vue?vue&type=script&lang=js&"
export * from "./starsParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports